import { useState } from 'react';

interface StartScreenProps {
  onStart: (username: string) => void;
}

export default function StartScreen({ onStart }: StartScreenProps) {
  const [username, setUsername] = useState('');
  const [isAnimating, setIsAnimating] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (username.trim()) {
      setIsAnimating(true);
      setTimeout(() => {
        onStart(username.trim());
      }, 500);
    }
  };

  return (
    <div className={`min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 transition-opacity duration-500 ${isAnimating ? 'opacity-0' : 'opacity-100'}`}>
      <div className="w-full max-w-2xl text-center">
        {/* Logo */}
        <div className="mb-8 sm:mb-12 animate-fadeIn">
          <div className="inline-block relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/8983347aa03bff9d8e2ebfb89c756642.jpg"
              alt="Roblox"
              className="h-20 sm:h-24 md:h-28 w-auto mx-auto drop-shadow-[0_0_20px_rgba(0,212,255,0.6)]"
              style={{ animation: 'pulse-glow 2s ease-in-out infinite' }}
            />
          </div>
        </div>

        {/* Main Title */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-4 sm:mb-6 animate-fadeInUp tracking-wider px-2" style={{ animationDelay: '0.2s' }}>
          <span className="bg-gradient-to-r from-white via-[#00d4ff] to-white bg-clip-text text-transparent">
            ИТОГИ ГОДА 2025
          </span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white/70 mb-12 sm:mb-16 animate-fadeInUp leading-relaxed px-4" style={{ animationDelay: '0.4s' }}>
          Узнай, каким был твой год в Roblox
        </p>

        {/* Input Form */}
        <form onSubmit={handleSubmit} className="animate-slideInUp px-4" style={{ animationDelay: '0.6s' }}>
          <div className="max-w-md mx-auto bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-2xl">
            <label className="block text-xs sm:text-sm font-medium text-white/60 mb-3 uppercase tracking-widest">
              Введите ваш игровой ник Roblox
            </label>
            
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Ваш ник..."
              className="w-full h-12 sm:h-14 bg-white/8 border-2 border-transparent rounded-xl sm:rounded-2xl px-4 sm:px-6 text-base sm:text-lg text-black placeholder-white/30 focus:outline-none focus:border-[#00d4ff] focus:shadow-[0_0_20px_rgba(0,212,255,0.3)] transition-all duration-300"
              required
            />

            <button
              type="submit"
              className="w-full h-14 sm:h-16 mt-4 sm:mt-5 bg-gradient-to-r from-[#00d4ff] to-[#a855f7] rounded-xl sm:rounded-2xl text-white text-base sm:text-lg font-bold shadow-[0_8px_32px_rgba(0,212,255,0.3)] hover:scale-[1.02] hover:shadow-[0_12px_40px_rgba(0,212,255,0.5)] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Узнать
            </button>

            <p className="mt-3 sm:mt-4 text-xs text-white/40 leading-relaxed px-2">
              Мы используем ваш ник, чтобы собрать персональные итоги года.
            </p>
          </div>
        </form>

        {/* Decorative lights */}
        <div className="hidden sm:block absolute top-10 left-10 w-2 h-2 bg-[#ffd700] rounded-full animate-pulse" style={{ boxShadow: '0 0 20px #ffd700' }} />
        <div className="hidden sm:block absolute top-20 right-20 w-2 h-2 bg-[#00d4ff] rounded-full animate-pulse" style={{ animationDelay: '0.5s', boxShadow: '0 0 20px #00d4ff' }} />
        <div className="hidden sm:block absolute bottom-32 left-20 w-2 h-2 bg-[#a855f7] rounded-full animate-pulse" style={{ animationDelay: '1s', boxShadow: '0 0 20px #a855f7' }} />
        <div className="hidden sm:block absolute bottom-20 right-32 w-2 h-2 bg-[#ffd700] rounded-full animate-pulse" style={{ animationDelay: '1.5s', boxShadow: '0 0 20px #ffd700' }} />
      </div>
    </div>
  );
}
